import Controller from 'cio/pods/base/overview/recipients/index/controller';
export default Controller;
